function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AppShell } from '../app-shell';
import LoadingIndicator from '../../components/loading-indicator/loading-indicator';
import { CaseJson } from '../../views/case/case-json/case-json';
import classnames from 'classnames';
import ReactJson from 'react-json-view';
var _React_Component;
export class JSONViewApp extends (_React_Component = React.Component) {
    componentDidMount() {
        if (!this.hasInlineJson) this.props.onLoad();
    }
    _handleProcessIdChange(event) {
        event.preventDefault();
        const target = event.target || document.createElement('div');
        const linkable = target?.closest('a');
        if (!linkable) return;
        const item = linkable.attributes.getNamedItem('data-process-id');
        if (!item) return;
        const processId = parseInt(item.value);
        if (!processId) return;
        if (processId === this.props.activeCaseRun.process_instance_id) return;
        const caseRuns = this.props.activeItem?.caseRuns;
        if (!caseRuns) return;
        const soughtRun = caseRuns.find((caseRun)=>caseRun.process_instance_id === processId);
        if (!soughtRun) return;
        this.props.setActiveProcess(soughtRun);
    }
    render() {
        const { props } = this;
        const { loading, locked, activeItem, activeCaseRun } = props;
        const styleClasses = [
            'centered-application'
        ];
        let inner;
        if (this.hasInlineJson) {
            inner = /*#__PURE__*/ _jsx(ReactJson, {
                src: this.jsonData,
                displayObjectSize: false,
                displayDataTypes: false,
                theme: 'ocean'
            });
        } else {
            if (locked) {
                styleClasses.push(`cmx-application-locked`);
            }
            if (loading) {
                styleClasses.push(`cmx-application-masked`, `cmx-application-loading`, 'loading-view');
                inner = /*#__PURE__*/ _jsx("div", {
                    "data-testid": "loadingIndicator",
                    children: /*#__PURE__*/ _jsx(LoadingIndicator, {
                        text: `Loading JSON...`
                    })
                });
            } else if (activeItem !== null) {
                styleClasses.push(`cmx-application-loaded`);
                inner = /*#__PURE__*/ _jsx(CaseJson, {
                    caseDetail: activeItem,
                    activeCaseRun: activeCaseRun,
                    onClick: this._handleProcessIdChange
                });
            }
        }
        return /*#__PURE__*/ _jsx(AppShell, {
            registerActivity: props.registerActivity,
            children: /*#__PURE__*/ _jsxs("div", {
                className: classnames(styleClasses),
                children: [
                    locked && /*#__PURE__*/ _jsx("div", {
                        className: "locked-message",
                        children: "The case details you were viewing are no longer active."
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "centered-application-wrapper",
                        children: inner
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props), _define_property(this, "hasInlineJson", void 0), _define_property(this, "jsonData", void 0);
        const searchParams = new URLSearchParams(window.location.search);
        this.hasInlineJson = searchParams.has('hasInlineJson');
        if (this.hasInlineJson) {
            this.jsonData = JSON.parse(sessionStorage.getItem('json_view_data') ?? '');
        } else {
            this.jsonData = {};
        }
        this._handleProcessIdChange = this._handleProcessIdChange.bind(this);
    }
}
_define_property(JSONViewApp, "defaultProps", {
    activeItem: null,
    loading: true
});
